import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check, AlertCircle } from 'lucide-react';
export function ProductReveal() {
  return <section className="w-full bg-[#050505] py-24 px-4 relative overflow-hidden" data-id="element-767">
      {/* Background Gradient */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-[#050505] via-[#0a0a0a] to-[#050505] pointer-events-none" data-id="element-768"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-769">
        {/* TRANSITION */}
        <div className="text-center mb-24 space-y-8" data-id="element-770">
          <h2 className="font-serif text-3xl md:text-4xl text-[#f5f0e8]" data-id="element-771">
            ¿Qué se hace? <br data-id="element-772" />
            <span className="text-[#d4af37]" data-id="element-773">
              Ser más mecánico donde eres más vulnerable.
            </span>
          </h2>

          <div className="flex flex-wrap justify-center gap-4 text-sm md:text-base text-[#8a8578] italic" data-id="element-774">
            <span className="border-b border-red-900/50 pb-1" data-id="element-775">
              "esta vez es diferente"
            </span>
            <span className="border-b border-red-900/50 pb-1" data-id="element-776">
              "solo un trade más"
            </span>
            <span className="border-b border-red-900/50 pb-1" data-id="element-777">
              "si recupero, cierro"
            </span>
          </div>

          <p className="text-2xl md:text-3xl font-serif text-[#d4af37] pt-8" data-id="element-778">
            Tu mente no necesita razón. <br data-id="element-779" />
            Solo necesita alivio.
          </p>
        </div>

        {/* PRODUCT SHOWCASE */}
        <div className="bg-[#080808] border border-[#222] rounded-2xl p-8 md:p-12 shadow-2xl shadow-black/50" data-id="element-780">
          <div className="text-center mb-12" data-id="element-781">
            <span className="text-[#d4af37] text-sm font-bold tracking-[0.2em] uppercase" data-id="element-782">
              Presentando
            </span>
            <h3 className="font-serif text-3xl md:text-5xl text-[#f5f0e8] mt-4 mb-4 leading-tight" data-id="element-783">
              El Protocolo PP-7 <br data-id="element-784" />
              <span className="text-[#d4af37] text-2xl md:text-4xl" data-id="element-785">
                (Procedimiento de Intervención en Tiempo Real)
              </span>
            </h3>
            <p className="text-[#8a8578] max-w-xl mx-auto" data-id="element-786">
              El sistema mecánico que te obliga a mantenerte plano cuando tus
              emociones intentan tomar el control de tu cuenta.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16" data-id="element-787">
            <div className="relative" data-id="element-788">
              <div className="absolute inset-0 bg-[#d4af37]/10 blur-[40px] rounded-full" data-id="element-789"></div>
              <img src="https://cdn.magicpatterns.com/uploads/tk7sT8DRhqDxSJzYEtz6TD/Imagen_referencia_trading_en_paz.png" alt="Trading en Paz Product" className="relative z-10 w-full rounded-lg shadow-lg transform hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" data-id="element-790" />
            </div>

            <div className="space-y-8" data-id="element-791">
              <div className="space-y-2" data-id="element-792">
                <h4 className="text-xl font-serif text-[#f5f0e8] flex items-center gap-3" data-id="element-793">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#d4af37] text-black font-bold text-sm" data-id="element-794">
                    1
                  </span>
                  Protocolo Plano (PP-7)
                </h4>
                <p className="text-[#8a8578] pl-11 text-sm leading-relaxed" data-id="element-795">
                  Herramienta de intervención en tiempo real. Corta el sabotaje
                  antes de que crezca.
                </p>
              </div>

              <div className="space-y-2" data-id="element-796">
                <h4 className="text-xl font-serif text-[#f5f0e8] flex items-center gap-3" data-id="element-797">
                  <span className="flex items-center justify-center w-8 h-8 rounded-full bg-[#d4af37] text-black font-bold text-sm" data-id="element-798">
                    2
                  </span>
                  Reprogramación Identitaria (RI-3)
                </h4>
                <p className="text-[#8a8578] pl-11 text-sm leading-relaxed" data-id="element-799">
                  Sistema de identidad para que el sabotaje aparezca cada vez
                  menos.
                </p>
              </div>
            </div>
          </div>

          {/* DEEP DIVE: PP-7 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-800">
            <div className="bg-[#111] p-6 rounded-lg border border-[#333]" data-id="element-801">
              <div className="flex items-center gap-2 mb-4 text-[#d4af37]" data-id="element-802">
                <AlertCircle size={20} data-id="element-803" />
                <h4 className="font-bold tracking-wide text-sm" data-id="element-804">
                  PP-7: LOS GATILLOS
                </h4>
              </div>
              <p className="text-[#f5f0e8] text-sm mb-4" data-id="element-805">
                Si aparece este gatillo → aplico esta respuesta.
              </p>
              <ul className="space-y-2 text-sm text-[#8a8578]" data-id="element-806">
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-807">
                  <span data-id="element-808">FOMO</span>
                  <span className="text-[#f5f0e8]" data-id="element-809">
                    Pausa 90s + regla "2 velas"
                  </span>
                </li>
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-810">
                  <span data-id="element-811">Pérdida reciente</span>
                  <span className="text-[#f5f0e8]" data-id="element-812">
                    Cierre 3 min + respiración
                  </span>
                </li>
                <li className="flex justify-between border-b border-[#222] pb-2" data-id="element-813">
                  <span data-id="element-814">Euforia</span>
                  <span className="text-[#f5f0e8]" data-id="element-815">Reduzco tamaño al 70%</span>
                </li>
              </ul>
            </div>

            {/* DEEP DIVE: RI-3 */}
            <div className="bg-[#111] p-6 rounded-lg border border-[#333]" data-id="element-816">
              <div className="flex items-center gap-2 mb-4 text-[#d4af37]" data-id="element-817">
                <Check size={20} data-id="element-818" />
                <h4 className="font-bold tracking-wide text-sm" data-id="element-819">
                  RI-3: IDENTIDAD
                </h4>
              </div>
              <div className="space-y-4" data-id="element-820">
                <div data-id="element-821">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-822">
                    A) Lenguaje
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-823">
                    "No reparo dolor con clicks."
                  </p>
                </div>
                <div data-id="element-824">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-825">
                    B) Ritual
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-826">
                    Semáforo + Checklist (60 seg)
                  </p>
                </div>
                <div data-id="element-827">
                  <p className="text-[#f5f0e8] text-sm font-medium" data-id="element-828">
                    C) Evidencia
                  </p>
                  <p className="text-xs text-[#8a8578]" data-id="element-829">
                    Diario mínimo de obediencia
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="text-center border-t border-[#222] pt-12" data-id="element-830">
            <p className="font-serif text-xl md:text-2xl text-[#f5f0e8] leading-relaxed" data-id="element-831">
              "Trading en paz no significa no sentir. <br data-id="element-832" />
              <span className="text-[#d4af37]" data-id="element-833">
                Significa no obedecerle al sentimiento.
              </span>
              "
            </p>
          </div>
        </div>
      </div>
    </section>;
}